import { Icon, IconProps } from '@chakra-ui/react'

export default function CommentsNewIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7.5 3h10v10.833l-2.5-2.5H7.5V3z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M12.435 7.103h-10L2.5 18 5 15.5h7.5l-.065-8.397z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
